import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

const REVEAL_CONFIGS = {
    "fade-up":    { from: { opacity: 0, y: 24 },  to: { opacity: 1, y: 0 } },
    "fade-in":    { from: { opacity: 0 },         to: { opacity: 1 } },
    "fade-left":  { from: { opacity: 0, x: -32 }, to: { opacity: 1, x: 0 } },
    "fade-right": { from: { opacity: 0, x: 32 },  to: { opacity: 1, x: 0 } },
};

export class AOS {
    init() {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const elements = Array.from(document.querySelectorAll("[data-aos]"));
        if (elements.length === 0) return;

        if (prefersReducedMotion) {
            elements.forEach((el) => el.classList.add("aos-ready"));
            return;
        }

        const groups = new Map();
        elements.forEach((el) => {
            const type = el.dataset.aos;
            if (!REVEAL_CONFIGS[type]) return;
            if (!groups.has(type)) groups.set(type, []);
            groups.get(type).push(el);
        });

        groups.forEach((items, type) => {
            const { from, to } = REVEAL_CONFIGS[type];
            gsap.set(items, from);
            items.forEach((el) => el.classList.add("aos-ready"));

            ScrollTrigger.batch(items, {
                start: "top 85%",
                once: true,
                onEnter: (batch) => {
                    gsap.to(batch, {
                        ...to,
                        duration: 0.7,
                        ease: "power2.out",
                        stagger: 0.08,
                        delay: (i, target) => (Number(target.dataset.aosDelay) || 0) / 1000,
                    });
                },
            });
        });
    }
}
